"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvailability = exports.isObjectWithData = exports.canHaveClosestDate = exports.getSelectabilityForCheckout = exports.getSelectabilityForCheckIn = exports.getSelectabilityMessageForCheckout = exports.getIsSelectableForCheckout = exports.getIsSelectableForCheckIn = exports.getIsInvalidDayOfWeek = exports.getIsInvalidChangeover = exports.getIsAfterCheckIn = exports.getMaxStayExceeded = exports.getMinStayMet = exports.getNextDay = exports.chooseClosestDate = exports.prepDateForComparison = exports.getUTCDate = exports.dateIsMatch = exports.convertDashesToSlashes = exports.convertDateObjToString = void 0;
const index_1 = __importDefault(require("date-fns/format/index"));
const index_2 = __importDefault(require("date-fns/isBefore/index"));
const index_3 = __importDefault(require("date-fns/isSameDay/index"));
const constants_1 = require("./constants");
const convertDateObjToString = (date) => (0, index_1.default)(new Date(date.year, date.month - 1, date.day), constants_1.DATE_FORMAT);
exports.convertDateObjToString = convertDateObjToString;
const convertDashesToSlashes = (date) => {
    if (date && typeof date === 'object') {
        date = (0, exports.convertDateObjToString)(date);
    }
    /*
     * if there is no date we return an empty string vs. null
     * an empty string returns an 'Invaild date' when creating a new Date()
     * where null will return the vaild date of "Dec 31, 1969"
     */
    return date && typeof date === 'string' ? date.replace(/-/g, '/') : '';
};
exports.convertDashesToSlashes = convertDashesToSlashes;
const dateIsMatch = (dateOutput, matchCriteria, today) => {
    /*
     * iterate each key/value pair in match criteria
     * for each, check if dateObj[key] is value
     * as long as the values match, return true
     * if we find a mismatch, return false
     */
    if (!(0, exports.isObjectWithData)(dateOutput) || !(0, exports.isObjectWithData)(matchCriteria)) {
        return null;
    }
    /*
     * if the dateOutput is before today
     * we should not return a match
     */
    if ((0, index_2.default)(dateOutput.dateObj, new Date((0, exports.convertDashesToSlashes)(today)))) {
        return false;
    }
    for (let key of Object.keys(matchCriteria)) {
        if (dateOutput[key] !== matchCriteria[key]) {
            return false;
        }
    }
    return true;
};
exports.dateIsMatch = dateIsMatch;
const getUTCDate = (date) => {
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
};
exports.getUTCDate = getUTCDate;
const prepDateForComparison = (parsedAvailability, date, //added & subtracted
matchCriteria, today) => {
    let availabilityForDate = {};
    availabilityForDate.formatted = (0, index_1.default)((0, exports.getUTCDate)(date), constants_1.DATE_FORMAT);
    availabilityForDate.availability =
        parsedAvailability[availabilityForDate.formatted] || null;
    if (!availabilityForDate.availability) {
        if (parsedAvailability.defaults) {
            availabilityForDate.availability = parsedAvailability.defaults;
            availabilityForDate.isMatch = (0, exports.dateIsMatch)(availabilityForDate.availability, matchCriteria, today);
            return availabilityForDate;
        }
        return null;
    }
    availabilityForDate.isMatch = (0, exports.dateIsMatch)(availabilityForDate.availability, matchCriteria, today);
    return availabilityForDate;
};
exports.prepDateForComparison = prepDateForComparison;
const chooseClosestDate = (futureDate, pastDate, leanEarly) => {
    if ((futureDate.isMatch && !pastDate.isMatch) ||
        (futureDate.isMatch && !leanEarly)) {
        return futureDate.formatted;
    }
    if ((pastDate.isMatch && !futureDate.isMatch) ||
        (pastDate.isMatch && leanEarly)) {
        return pastDate.formatted;
    }
    return null;
};
exports.chooseClosestDate = chooseClosestDate;
const getNextDay = (date) => {
    if (date) {
        date.setDate(date.getDate() + 1);
        return {
            dateObj: date,
            dateText: (0, index_1.default)(date, constants_1.DATE_FORMAT),
        };
    }
    return {
        dateObj: null,
        dateText: null,
    };
};
exports.getNextDay = getNextDay;
const getMinStayMet = (daysSinceCheckIn, minStayForCheckInDate) => daysSinceCheckIn >= minStayForCheckInDate;
exports.getMinStayMet = getMinStayMet;
const getMaxStayExceeded = (daysSinceCheckIn, maxStayForCheckInDate) => daysSinceCheckIn > maxStayForCheckInDate;
exports.getMaxStayExceeded = getMaxStayExceeded;
const getIsAfterCheckIn = (daysSinceCheckIn) => daysSinceCheckIn > 0;
exports.getIsAfterCheckIn = getIsAfterCheckIn;
const getIsInvalidChangeover = (checkoutValidity) => checkoutValidity === constants_1.INPUT_CHECKOUT_VALS.CHANGEOVER_EXCLUSION;
exports.getIsInvalidChangeover = getIsInvalidChangeover;
const getIsInvalidDayOfWeek = (checkoutValidity) => checkoutValidity === constants_1.INPUT_CHECKOUT_VALS.NON_CHANGEOVER_DAY_OF_WEEK;
exports.getIsInvalidDayOfWeek = getIsInvalidDayOfWeek;
const getIsSelectableForCheckIn = (checkinValidity) => checkinValidity === constants_1.INPUT_CHECK_IN_VALS.VALID;
exports.getIsSelectableForCheckIn = getIsSelectableForCheckIn;
const getIsSelectableForCheckout = ({ isAfterCheckIn, minStayMet, maxStayWindowExceeded, invalidDayOfWeek, invalidChangeover, }) => isAfterCheckIn &&
    minStayMet &&
    !maxStayWindowExceeded &&
    !invalidDayOfWeek &&
    !invalidChangeover;
exports.getIsSelectableForCheckout = getIsSelectableForCheckout;
const getSelectabilityMessageForCheckout = ({ isAfterCheckIn, minStayMet, maxStayWindowExceeded, invalidChangeover, invalidDayOfWeek, }) => {
    const { CHECKOUT_BEFORE_CHECKIN, MIN_STAY_NOT_MET, MAX_STAY_WINDOW_EXCEEDED, CHANGEOVER_EXCLUSION, NON_CHANGEOVER_DAY_OF_WEEK, VALID, } = constants_1.OUTPUT_CHECKOUT_VALS;
    return ((!isAfterCheckIn && CHECKOUT_BEFORE_CHECKIN) ||
        (!minStayMet && MIN_STAY_NOT_MET) ||
        (maxStayWindowExceeded && MAX_STAY_WINDOW_EXCEEDED) ||
        (invalidChangeover && CHANGEOVER_EXCLUSION) ||
        (invalidDayOfWeek && NON_CHANGEOVER_DAY_OF_WEEK) ||
        VALID);
};
exports.getSelectabilityMessageForCheckout = getSelectabilityMessageForCheckout;
const getSelectabilityForCheckIn = ({ dateIndex, days, thisDay, }) => {
    const { checkinValidity } = days[dateIndex];
    thisDay.isSelectable = (0, exports.getIsSelectableForCheckIn)(checkinValidity);
    thisDay.selectabilityMessage = checkinValidity;
};
exports.getSelectabilityForCheckIn = getSelectabilityForCheckIn;
const getSelectabilityForCheckout = ({ checkInDay, dateIndex, days, stayConstraints: constraints, thisDay, timeProgression: time, }) => {
    const { stayConstraints, checkoutValidity } = days[dateIndex];
    const { minimumStayInDays, maximumStayInDays } = stayConstraints;
    const rules = {
        invalidChangeover: null,
        invalidDayOfWeek: null,
    };
    if ((0, index_3.default)(checkInDay.dateObj, thisDay.dateObj)) {
        // determine constraints for check in date
        time.daysSinceCheckIn = 0;
        constraints.minStay = minimumStayInDays;
        constraints.maxStay = maximumStayInDays;
    }
    else if (time.daysSinceCheckIn >= 0) {
        // calculate validity of each potential checkout date
        time.daysSinceCheckIn++;
        time.isAfterCheckIn = (0, exports.getIsAfterCheckIn)(time.daysSinceCheckIn);
        time.minStayMet = (0, exports.getMinStayMet)(time.daysSinceCheckIn, constraints.minStay);
        time.maxStayWindowExceeded = (0, exports.getMaxStayExceeded)(time.daysSinceCheckIn, constraints.maxStay);
        // determine whether checkout is allowed based on owner rules
        rules.invalidChangeover = (0, exports.getIsInvalidChangeover)(checkoutValidity);
        rules.invalidDayOfWeek = (0, exports.getIsInvalidDayOfWeek)(checkoutValidity);
    }
    thisDay.isSelectable = (0, exports.getIsSelectableForCheckout)(Object.assign(Object.assign({}, time), rules));
    thisDay.selectabilityMessage = (0, exports.getSelectabilityMessageForCheckout)(Object.assign(Object.assign({}, time), rules));
};
exports.getSelectabilityForCheckout = getSelectabilityForCheckout;
const canHaveClosestDate = (date, parsedAvailability, matchCriteria) => !!date &&
    (0, exports.isObjectWithData)(parsedAvailability) &&
    (0, exports.isObjectWithData)(matchCriteria);
exports.canHaveClosestDate = canHaveClosestDate;
const isObjectWithData = (possibleObject) => !!possibleObject &&
    typeof possibleObject === 'object' &&
    Object.keys(possibleObject).length > 0;
exports.isObjectWithData = isObjectWithData;
const getAvailability = (previousDayAvailable, dateAvailability) => {
    if (previousDayAvailable) {
        if (dateAvailability) {
            return 'available';
        }
        return 'pm-unavailable';
    }
    return dateAvailability ? 'am-unavailable' : 'unavailable';
};
exports.getAvailability = getAvailability;
